import React from 'react';
import { Form } from 'react-bootstrap';

// Styles
import styles from "./../StaffManagment.module.css";
import Dstyles from "../../../Dashboard/DashboardFileManagement/DashboardFileManagement.module.css"

const StaffMessageForm = (props) => {
    return (
        <>
            <div dir="rtl" className={`mt-2 mx-4 px-2 text-right`}>
                <Form.Group className={`${styles.total_form_group} mb-4 pb-4 d-flex flex-column w-100`}>
                    <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="messageText"> متن پیام </Form.Label>
                    <Form.Control
                        style={{ resize: "none" }}
                        className={`${styles.form_control_input} shadow-none`}
                        as="textarea"
                        rows={7}
                        placeholder="متن پیام اینجا نوشته شود"
                        id="messageText"
                        name="messageText"
                        value={props.formStaffMessage.messageText}
                        onChange={props.formStaffMessageChangeHandler}
                    />
                </Form.Group>

                <div className="d-flex justify-content-end align-items-center mt-5 mb-2">
                    {props.btnLoader ? (
                        <div className={Dstyles.btn_loader_container}>
                            <div className={Dstyles.btn_spinner}></div>
                        </div>
                    )
                        : (
                            <div className={`${styles.total_save_btn} text-center d-flex justify-content-center align-items-center me-3`} role="button" onClick={props.submitHandler}>
                                <button className={`border-0 bg-transparent text-white`}>ارسال</button>
                            </div>
                        )
                    }
                </div>
            </div>
        </>
    )
}

export default StaffMessageForm;
